export const getters = {
  getSelectedLinkId: (state) => (guid) => state.browserItemsSelections[guid],
  getBrowserItemsOrder: (state) => (guid) => state.browserItemsOrder[guid],
  selectedLanguage: (state) => state.selectedLanguage,
  selectedZoneOfConsume: (state) => state.selectedZoneOfConsume,
  getProductPrice: (state) => (productGuid) => (state.prices[state.selectedZoneOfConsume] ? state.prices[state.selectedZoneOfConsume][productGuid] : undefined),
  userDefinedData: (state) => state.userDefinedData,
  ticket: (state) => state.ticket,
  saleLocationGuid: (state) => state.saleLocationGuid,
  subdomain: (state) => state.subdomain,
  status: (state) => state.status,
  currencySymbol: (state) => state.currencySymbol,
  currencyPosition: (state) => state.currencyPosition,
  showFeatures: (state) => state.showFeatures,
  showProductTags: (state) => state.showProductTags,
  showIconFeatures: (state) => state.showIconFeatures,
  showIconProductTags: (state) => state.showIconProductTags,
  getSrollBrowserSelected: (state) => (guid) => state.scrollBrowserSelected[guid],
  getClauseGuidWithSectionsGuid: (state) => state.clauseGuidWithSectionsGuid,
  getQtyTotalShop: (state) => {
    let count = 0;
    Object.entries(state.shopList).forEach(([key, value]) => {
      count += value.qty;
    });
    return count;
  },
  getTotalSumShop: (state) => {
    let total = 0;
    Object.entries(state.shopList).forEach(([key, value]) => {
      total += value.productUnitPrice * value.qty;
    });
    return total;
  },
  getShopList: (state) => state.shopList,
  getTableGuid: (state) => state.tableGuid
};
